module.exports = __webpack_public_path__ + "img/re.5ee3d9c8.svg";